export enum CsvRowType {
  Definition = 'Definition',
  Translation = 'Translation',
  Account = 'Account',
  StyleTemplate = 'StyleTemplate',
  Scope = 'Scope',
  TestParameter = 'TestParameter',
  Parameter = 'Parameter'
}

export enum GroupCsvRowType {
  Definition = 'Definition',
  Translation = 'Translation',
  Account = 'Account',
  ParameterDetect = 'ParameterDetect',
  Arfd = 'Arfd',
  Mrl = 'Mrl',
  Count = 'Count'
}
